import { Body1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SearchTip.css';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import { IFullTipV2Schema } from 'shared/repositories/text-search/entities/tips/FullTipV2Schema';
import classNames from 'classnames';

interface ISearchTipProps {
  tip: IFullTipSchema | IFullTipV2Schema;
  isTipsDisabled?: boolean;
  onClick: (tip: IFullTipSchema | IFullTipV2Schema) => void;
}

export const SearchTip: React.FC<ISearchTipProps> = ({ tip, onClick, isTipsDisabled }) => {
  return (
    <div className={classNames(styles['tip'], isTipsDisabled && styles['disabled'])} onClick={() => onClick(tip)}>
      <Body1 color={isTipsDisabled ? 'text-primary-disabled' : 'text-main-default'}>{tip.text}</Body1>
    </div>
  );
};
